import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ReactComponent as ChevronIcon } from "feather-icons/dist/icons/chevron-right.svg";

/** Fil d'Ariane : Accueil › Blog › Catégorie › Article */

const Nav = tw.nav`text-sm font-medium text-gray-600`;
const List = tw.ol`flex flex-wrap items-center`;
const Item = styled.li`
  ${tw`inline-flex items-center`}
  svg {
    ${tw`w-4 h-4 mx-2 text-gray-400 flex-shrink-0`}
  }
`;
const Crumb = styled(Link)`
  ${tw`hocus:text-primary-500 transition duration-300 border-b-2 border-transparent hocus:border-primary-500`}
`;
const Current = tw.span`text-gray-900 font-semibold`;

export default function Breadcrumb({ items }) {
  if (!items || !items.length) return null;
  return (
    <Nav aria-label="Fil d'Ariane">
      <List>
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <Item key={i}>
              {i > 0 && <ChevronIcon aria-hidden="true" />}
              {last || !item.to ? (
                <Current aria-current={last ? "page" : undefined}>{item.label}</Current>
              ) : item.external ? (
                <Crumb as="a" href={item.to}>
                  {item.label}
                </Crumb>
              ) : (
                <Crumb to={item.to}>{item.label}</Crumb>
              )}
            </Item>
          );
        })}
      </List>
    </Nav>
  );
}
